function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemoizedValue } from '@sail/react';
import { useContext, useMemo, useRef, useState } from 'react';
import { DEFAULT_DEBUG_BOUNDARY_VISIBLE, DEFAULT_SET_AND_UNSET_VALUE, DEFAULT_START_STOP_VALUE } from '../internal/constants';
import DebugBoundaryVisibleContext from '../internal/provider/DebugBoundaryVisibleContext';
import ObservabilityApiProvider from '../internal/provider/ObservabilityApiProvider';
import ObservabilityConfigProvider from '../internal/provider/ObservabilityConfigProvider';
import PerformanceMonitorStartStopContext from '../internal/provider/PerformanceMonitorStartStopContext';
import PerformanceMonitorTreeContext from '../internal/provider/PerformanceMonitorTreeContext';
import DebugBoundary from '../public/DebugBoundary';
import { v4 as uuidV4 } from 'uuid';
/**
 * @see https://sail.stripe.me/apis/observability/ObservabilityProvider
 * @see https://sail.stripe.me/apis/observability/ErrorBoundary
 */ export default function ObservabilityProvider(_param) {
    var { children } = _param, config = _object_without_properties(_param, [
        "children"
    ]);
    const stableConfig = useMemoizedValue(config);
    const startsRef = useRef(new Set());
    const stopsRef = useRef(new Set());
    const debugBoundaryVisibleParent = useContext(DebugBoundaryVisibleContext);
    const setUnsetParent = useContext(PerformanceMonitorTreeContext);
    const startStopParent = useContext(PerformanceMonitorStartStopContext);
    const setUnsetCurrent = useMemo(()=>{
        return {
            set (start, stop) {
                startsRef.current.add(start);
                stopsRef.current.add(stop);
            },
            unset (start, stop) {
                startsRef.current.delete(start);
                stopsRef.current.delete(stop);
            }
        };
    }, []);
    const startStopCurrent = useMemo(()=>{
        return {
            start: (reason)=>{
                const uuid = uuidV4();
                startsRef.current.forEach((start)=>start(uuid, reason));
            },
            stop: (reason)=>{
                stopsRef.current.forEach((stop)=>stop(reason));
            }
        };
    }, []);
    const [visibleCategories, setVisibleCategories] = useState(new Set());
    const debugBoundaryVisibleCurrent = useMemo(()=>[
            visibleCategories,
            setVisibleCategories
        ], [
        visibleCategories
    ]);
    const setUnset = setUnsetParent === DEFAULT_SET_AND_UNSET_VALUE ? setUnsetCurrent : setUnsetParent;
    const start = startStopParent === DEFAULT_START_STOP_VALUE ? startStopCurrent : startStopParent;
    const debugBoundaryVisible = debugBoundaryVisibleParent === DEFAULT_DEBUG_BOUNDARY_VISIBLE ? debugBoundaryVisibleCurrent : debugBoundaryVisibleParent;
    return /*#__PURE__*/ _jsx(PerformanceMonitorTreeContext.Provider, {
        value: setUnset,
        children: /*#__PURE__*/ _jsx(PerformanceMonitorStartStopContext.Provider, {
            value: start,
            children: /*#__PURE__*/ _jsx(DebugBoundaryVisibleContext.Provider, {
                value: debugBoundaryVisible,
                children: /*#__PURE__*/ _jsx(ObservabilityConfigProvider, {
                    config: stableConfig,
                    children: /*#__PURE__*/ _jsx(ObservabilityApiProvider, {
                        children: /*#__PURE__*/ _jsx(DebugBoundary, {
                            category: "ObservabilityProvider",
                            name: stableConfig.project,
                            color: "#513DD9",
                            children: children
                        })
                    })
                })
            })
        })
    });
}

//# sourceMappingURL=ObservabilityProvider.js.map